export { EmbedPage } from './embed.page';
